import React, { useState, useEffect, useRef } from 'react';
import { Avatar } from 'primereact/avatar';
import { useHistory } from 'react-router-dom';
import { Storage } from 'aws-amplify';

import MessageBox from './MessageBox';
import CaseLeadContainer from '../CaseLeadContainer/CaseLeadContainer';
import ImageComponent from 'shared/ImageComponent';
import { listCasesForUser } from 'services/CaseServices';
import { useUserDetailsContext } from 'context/userDetailsContext';
import { toastConstant } from 'constants/toastmessage';
import { useToast } from 'context/ToastContext';
import { handleRedirection } from 'utils/utils';
import { FILEUPLOAD_S3, FILEUPLOAD_S3_LEVEL, SetS3Config } from 'config/amplify_config';
import { uuidv4 } from 'common/uuidGenerator';
import { listMessageHistory, messageMarkRead, sendTextMessage } from 'services/messages/textMessageService';
import { useWebSocketContext } from 'context/WebSocketConnectionContext';
import { generateFullName } from 'utils/generateFullNameUtils';
import Cookies from 'universal-cookie';
import { useNavbarContext } from 'context/NavbarContext';
import { validateUpload } from 'services/fileManager/fileManagerServices';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
const cookie = new Cookies();

const tenantId = cookie.get('tenantId') || null;

const fileUpload = async (file, setUploadindStatus, idForFolder) => {
  const caseFolder = idForFolder ? `${idForFolder}/` : '';
  const file_location = `text_messaging/${tenantId}/${caseFolder}/${uuidv4()}#$#${encodeURIComponent(file?.name)}`;
  SetS3Config(FILEUPLOAD_S3, FILEUPLOAD_S3_LEVEL);

  setUploadindStatus(true);
  let response = await Storage.put(file_location, file, {
    contentType: file?.type,
    useAccelerateEndpoint: true,
  }).catch(() => setUploadindStatus(false));
  setUploadindStatus(false);

  if (response.key) {
    return response.key;
  } else {
    return false;
  }
};

export default function MessageContainer(props) {
  const {
    handleSelectThread,
    isFromCase,
    leadDetails,
    caseDetails,
    selectedThread,
    newThreadActive,
    navigateToLatest,
    setMessageThreads,
    onMountUnMount,
    onOperationBreak,
    fetchTextMessages,
    selectedContact,
    messageThreads,
    isFromLead,
    activeIndex,
  } = props;
  const history = useHistory();
  const { addToast } = useToast();
  const websocket = useWebSocketContext();
  const userContext = useUserDetailsContext();
  const listRef = useRef(null);

  const [caseLeadList, setCaseLeadList] = useState(null);
  const [file, setFile] = useState(null);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentOffset, setCurrentOffset] = useState(0);
  const [hasMoreMessages, setHasMoreMessages] = useState(true);
  const [isClientOptIn, setIsClientOptIn] = useState(null);
  const [uploadindStatus, setUploadindStatus] = useState(false);
  const [isNewThread, setIsNewThread] = useState(false);
  const skipNextFetchRef = useRef(false); // Flag to skip fetch after first message sent on new thread
  const justSentFirstMessageRef = useRef(false); // Flag to prevent fetchTextMessages call after sending first message

  const { notificationData } = useNavbarContext();

  useEffect(() => {
    if (websocket?.textMessageData?.body?.from) {
      if (
        selectedThread?.from_ === websocket?.textMessageData?.body?.from ||
        selectedThread?.to === websocket?.textMessageData.body?.from
      ) {
        const timestamp = websocket?.textMessageData?.time;
        const messageData = {
          from: websocket?.textMessageData?.body?.from,
          to: selectedThread?.to,
          body: websocket?.textMessageData?.body?.message_body,
          media_url: websocket?.textMessageData?.body?.media_url ?? websocket?.textMessageData?.body?.mms_path,
          MediaContentType0: websocket?.textMessageData?.body?.media_content_type ?? '',
          mms_path: websocket?.textMessageData?.body?.mms_path ?? '',
          created_at: timestamp,
        };
        setMessages((preVal) => [...preVal, messageData]);

        // Update the thread list with the new message and mark as read
        // Since the user is actively viewing this thread, it should be marked as read immediately
        setMessageThreads((prevThreads) => {
          const threadIndex = prevThreads.findIndex(
            (thread) =>
              (thread.from_ === websocket?.textMessageData?.body?.from || thread.to === websocket?.textMessageData?.body?.from) &&
              thread.contact_id === selectedThread?.contact_id
          );

          if (threadIndex > -1) {
            const updatedThread = {
              ...prevThreads[threadIndex],
              last_message: websocket?.textMessageData?.body?.message_body,
              last_updated: timestamp,
              last_author: 'client',
              unread_reply_count: 0, // Mark as read since thread is currently open
              is_read: true, // Explicitly mark as read
            };

            // Move the updated thread to the top of the list
            const newThreads = [...prevThreads];
            newThreads.splice(threadIndex, 1); // Remove from current position
            newThreads.unshift(updatedThread); // Add to the beginning

            return newThreads;
          }

          return prevThreads;
        });

        // Mark the message as read in the backend since the user is viewing the thread
        if (selectedThread?.id) {
          messageMarkRead({
            firm_user_id: userContext?.firmDetails?.firm_user_id,
            thread_ids: [selectedThread?.id],
          })
            .then(() => {
              // Refresh notification count after marking as read
              notificationData?.loadNotificationCount();
            })
            .catch((err) => console.log('Error marking message as read:', err));
        }

        websocket.setTextMessageData();
      }
    }
    // delivery status Update Logic
    if (websocket?.textMessageData?.body?.SmsSid) {
      setMessages((preVal) =>
        preVal.map((message) => {
          if (message?.message_id === websocket?.textMessageData?.body?.SmsSid) {
            return { ...message, last_message_status: websocket?.textMessageData?.body?.SmsStatus };
          } else return message;
        })
      );
    }
  }, [websocket?.textMessageData]);

  const fetchMessageHistory = (contactId, date, phoneNumber, _offset = 0, unreadReplyCount, isRead) => {
    setLoading(true);

    // Mark as read only on initial load (offset === 0) and when thread has a valid id
    if (_offset === 0 && (unreadReplyCount > 0 || isRead === true) && isNewThread === false && selectedThread?.id) {
      messageMarkRead({
        firm_user_id: userContext?.firmDetails?.firm_user_id,
        thread_ids: [selectedThread?.id],
      })
        .then(() => {
          setMessageThreads((preval) =>
            preval.map((val) => {
              if (val.contact_id === contactId) {
                return { ...val, unread_reply_count: 0 };
              } else return val;
            })
          );

          //Fetching notification counts
          notificationData?.loadNotificationCount();
        })
        .catch((err) => console.log(err));
    }

    listMessageHistory({
      contact_id: contactId,
      message_date: date,
      phoneNumber,
      limit: 50,
      offset: _offset,
    })
      .then((response) => {
        setIsClientOptIn(response?.data?.is_client_opt_in);

        if (response?.data?.text_message_history?.length) {
          const newMessages = response.data.text_message_history;

          // Check if there are more messages
          // next_token will be null if this is the last page
          if (response?.data?.next_token !== null && response?.data?.next_token !== undefined) {
            setCurrentOffset(response.data.next_token);
            setHasMoreMessages(true);
          } else {
            setHasMoreMessages(false);
          }

          // Messages come in descending order (newest first), need to reverse for chat display
          let reverseData = JSON.parse(JSON.stringify(newMessages));
          let finalData = reverseData.reverse();

          if (_offset === 0) {
            // Initial load - replace all messages
            setMessages(finalData);
          } else {
            // Pagination - prepend older messages
            setMessages((preVal) => [...finalData, ...preVal]);
          }
        } else {
          if (_offset === 0) {
            setMessages([]);
          }
          setHasMoreMessages(false);
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setHasMoreMessages(false);
      });
  };

  const sendMessage = async ({ message }) => {
    isFromCase && typeof onMountUnMount === 'function' && onMountUnMount('text-message', 'mounted', caseDetails?.case_id);

    let sendData = {
      message_body: message,
      case_id: caseLeadList?.map((v) => v.case_id),
    };

    let file_path = '';
    let media_content_type = '';
    let display_filename = '';
    let size = 0;
    if (file) {
      const fileSize = file?.size;
      try {
        await validateUpload(fileSize);
      } catch (err) {
        let errorMsg = err?.response?.data?.message || err?.response?.data || err?.message || 'File validation failed';

        addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, errorMsg);
        return;
      }
      const folderId = caseLeadList?.map((v) => v.case_id)[0] || '';
      let fileResponse = await fileUpload(file, setUploadindStatus, folderId);

      if (fileResponse) {
        file_path = `public/${fileResponse}`;
        media_content_type = file.type;
      }

      display_filename = file?.name || '';
      size = file?.size || 0;
    }

    if (isFromCase) {
      sendData.text_message_case_id = caseDetails?.case_id;
    }
    let timeout;

    await sendTextMessage({
      contact_id: selectedThread?.contact_id,
      text_message_thread_sk: isNewThread ? '' : selectedThread?.sk ? selectedThread?.sk?.replaceAll('#', '%23') : '',
      file_path,
      media_content_type,
      display_filename,
      size: size?.toString(),
      data: sendData,
      is_lead: isFromLead,
    })
      .then((response) => {
        if (response?.data?.status === 'Failed') {
          addToast(
            false,
            toastConstant.toasterType.ERROR,
            toastConstant.api.FAILED,
            'Failed to send the message. Please provide a valid phone number.'
          );
          isFromCase && typeof onOperationBreak === 'function' && onOperationBreak();
        } else {
          timeout = setTimeout(() => {
            isFromCase && typeof onMountUnMount === 'function' && onMountUnMount('text-message', 'unmounted');
          }, 3000);
          // add last message in list
          setMessages((preVal) => [...preVal, { ...response?.data, created_at: new Date().toISOString() }]);
          //update message in thread list
          if (isNewThread) {
            // Create new thread object and preserve sk/id from response
            const newThread = {
              ...selectedThread,
              ...response?.data,
              last_message: response?.data?.body,
              last_updated: response?.data?.time,
              created_at: response?.data?.time,
              last_author: generateFullName(userContext?.profileData),
              to: selectedThread?.to, // Preserve the phone number with country code from createNewThread
              // Remove temporary navigation flags after first message is sent
              fromCreateThread: undefined,
              fromGoToThread: undefined,
            };
            // Update messageThreads first
            setMessageThreads((pre) => [newThread, ...pre]);
            setIsNewThread(false);
            // Set flags to skip fetches since we already have the message in local state
            skipNextFetchRef.current = true;
            justSentFirstMessageRef.current = true; // Prevent fetchTextMessages call below
            // Update parent's selectedThread state with the new thread data (sk, id, etc.)
            // The useEffect will see this flag and skip the fetch
            handleSelectThread(newThread);
          } else {
            setMessageThreads((pre) => {
              // Find the index of the thread we just sent a message to
              const threadIndex = pre.findIndex((item) => item.sk === selectedThread?.sk);

              if (threadIndex === -1) {
                return pre; // Thread not found, return unchanged
              }

              // Update the thread with new message data
              const updatedThread = {
                ...pre[threadIndex],
                last_message: response?.data?.body,
                last_updated: response?.data?.time,
                created_at: response?.data?.time,
                last_message_status: 'queued',
                message_id: response?.data?.message_id,
                last_author: generateFullName(userContext?.profileData),
              };

              // Create new array with updated thread moved to the top
              const newThreads = [...pre];
              newThreads.splice(threadIndex, 1); // Remove thread from current position
              newThreads.unshift(updatedThread); // Add updated thread to the beginning

              return newThreads;
            });
          }
          // Only fetch thread list if it's empty AND we didn't just send the first message
          // (justSentFirstMessageRef prevents duplicate fetch after adding thread to list)
          if (messageThreads?.length === 0 && !justSentFirstMessageRef.current) {
            // Build data object with appropriate filters
            let data = {};
            if (!isFromCase && !isFromLead) {
              // For global text messages, include practice area filter
              data = { practice_area_ids: [] };
            } else {
              // For case/lead specific text messages, include case_ids filter
              data = { practice_area_ids: [] };
              if (isFromCase && caseDetails?.case_id) {
                data.case_ids = [caseDetails.case_id];
              }
              if (isFromLead && leadDetails?.case_id) {
                data.case_ids = [leadDetails.case_id];
              }
            }
            // Pass is_read based on activeIndex: '' for All tab (0), false for Unread tab (1)
            fetchTextMessages(selectedContact?.contact_id, true, activeIndex === 0 ? '' : false, data);
          }
          // Reset flag after condition check
          if (justSentFirstMessageRef.current) {
            justSentFirstMessageRef.current = false;
          }
          setFile(null);
        }
      })
      .catch((error) => {
        clearTimeout(timeout);
        isFromCase && typeof onOperationBreak === 'function' && onOperationBreak();
        addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, 'Failed to send the message. ' + error?.response?.data);
      });
  };

  const loadCaseLeadList = (targetUserType, targetUserId, targetUserName) => {
    listCasesForUser(targetUserType, targetUserId, targetUserName, true, true)
      .then((response) => {
        setCaseLeadList(response.data);
      })
      .catch((err) => console.error(err));
  };

  const fileOnChange = async (e) => {
    const file = e?.target?.files?.[0] || e?.dataTransfer?.files?.[0];

    const maxSize = 600 * 1024; // 650 KB in bytes
    if (file?.size < maxSize) {
      setFile(file);
    } else {
      addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, 'File size must be less than 600KB');
    }
  };

  // Track previous thread to detect actual thread changes
  const prevThreadRef = useRef(null);

  useEffect(() => {
    prevThreadRef.current = null;
  }, [activeIndex]);

  useEffect(() => {
    if (selectedThread) {
      // Check if we should skip this fetch (after sending first message on new thread)
      if (skipNextFetchRef.current) {
        skipNextFetchRef.current = false;
        prevThreadRef.current = selectedThread;
        return; // Skip fetch but update ref
      }

      const prevThread = prevThreadRef.current;

      // Check if this is actually a new thread selection (different contact or phone number)
      // vs just an update to the same thread (e.g., after sending first message and getting sk/id)
      const isDifferentThread = !prevThread || prevThread.contact_id !== selectedThread.contact_id || prevThread.to !== selectedThread.to;

      // Check if unread count has increased (new message arrived via websocket)
      const hasNewUnreadMessages =
        prevThread && selectedThread.unread_reply_count > 0 && prevThread.unread_reply_count !== selectedThread.unread_reply_count;

      // Re-fetch if:
      // 1. Switching to a different thread (different contact or phone)
      // 2. Same thread but unread count increased (need to mark as read)
      // 3. Thread has unread messages (handles re-clicking same thread after it reappears in unread list
      //    with the same unread_reply_count)
      const shouldFetchHistory = isDifferentThread || hasNewUnreadMessages || selectedThread?.unread_reply_count > 0;

      // Only reset messages and fetch history if necessary
      if (shouldFetchHistory) {
        setMessages([]);
        setFile(null);
        setCurrentOffset(0);
        setHasMoreMessages(true);
        // Reset isNewThread when switching threads, unless it's from "Go to Thread" or "Create A New Thread" navigation
        if (!selectedThread?.fromGoToThread && !selectedThread?.fromCreateThread) {
          setIsNewThread(false);
        }

        fetchMessageHistory(
          selectedThread?.contact_id,
          false,
          selectedThread?.to?.replace('+1', '')?.replace('+91', ''),
          0, // Start with offset 0
          selectedThread?.unread_reply_count,
          selectedThread?.is_read
        );
        loadCaseLeadList('contact', selectedThread?.contact_id, generateFullName(selectedThread?.client_name));
      }

      // Update ref for next comparison
      prevThreadRef.current = selectedThread;
    }
  }, [selectedThread]);

  const removeFile = () => setFile(null);

  // Helper to get formatted phone number with country code for display
  const getDisplayPhoneNumber = () => {
    if (!selectedThread) return '';

    const countryCode = selectedThread?.country_code || '+1';
    let phoneNumber = selectedThread?.to || selectedThread?.phone || selectedThread?.latest_phone_number || '';

    // If phone number doesn't start with + or country code, add it
    if (phoneNumber && !phoneNumber.startsWith('+') && !phoneNumber.startsWith(countryCode)) {
      phoneNumber = `${countryCode}${phoneNumber}`;
    }

    return phoneNumber;
  };

  // Helper to get contact name - handles person, business, and location types
  const getContactDisplayName = () => {
    if (!selectedThread) return 'Contact';

    // Use generateFullName which handles title, first_name, middle_name, last_name
    const fullName = generateFullName(selectedThread?.client_name);

    // If no name generated, try fallback to title directly from selectedThread
    if (!fullName || fullName.trim() === '') {
      return selectedThread?.title || selectedThread?.client_name?.title || 'Contact';
    }

    return fullName;
  };

  const createNewThread = (newNumber) => {
    if (!newNumber) {
      console.warn('Cannot create new thread: phone number is missing');
      return;
    }

    setMessages([]);
    setIsNewThread(true);

    // Extract country code from phone number if it starts with +
    let countryCode = selectedThread?.country_code;
    let latestPhoneNumber = newNumber;

    // If phone number starts with +, try to extract country code
    if (newNumber.startsWith('+')) {
      // Common country codes: +1 (US/Canada), +91 (India), etc.
      if (newNumber.startsWith('+1')) {
        countryCode = '+1';
        latestPhoneNumber = newNumber;
      } else if (newNumber.startsWith('+91')) {
        countryCode = '+91';
        latestPhoneNumber = newNumber;
      }
    }

    handleSelectThread({
      ...selectedThread,
      to: newNumber,
      phone: newNumber,
      latest_phone_number: latestPhoneNumber,
      country_code: countryCode || selectedThread?.country_code,
      // Flag to indicate this thread was created from "Create A New Thread" button
      fromCreateThread: true,
    });
  };

  return (
    <div className="card-bg p-3 mt-3 h-100 d-flex flex-column overflow-hidden">
      <div className="border-bottom">
        <div className="col-12">
          {Boolean(selectedThread) ? (
            <Link
              className="d-flex align-items-center mb-2 text-decoration-none"
              to={selectedThread.contact_id ? `/contacts/${selectedThread.contact_id}` : '/contacts'}
            >
              <ImageComponent
                filePath={`${tenantId}/${selectedThread?.contact_id}/profile_image`}
                fileName={
                  selectedThread?.client_name?.first_name?.charAt(0) ||
                  selectedThread?.client_name?.title?.charAt(0) ||
                  selectedThread?.title?.charAt(0) ||
                  'C'
                }
                style={{ backgroundColor: '#2196F3', color: '#ffffff' }}
                fileSize="medium.jpg"
              />

              <div className="flex-column ms-3">
                <div className="redirection-link-no-text-transform">
                  <h5 className="caption-bold mb-0 redirection-link-no-text-transform">
                    {getContactDisplayName()} ({getDisplayPhoneNumber()})
                  </h5>
                </div>
                <div className="F-size12">Contact</div>
              </div>
            </Link>
          ) : (
            <div className="d-flex align-items-center mb-2">
              <Avatar size="large" />
            </div>
          )}
        </div>
      </div>

      <div className="d-flex flex-grow-1 mt-2 overflow-hidden">
        <MessageBox
          {...{
            currentOffset,
            hasMoreMessages,
            fileOnChange,
            file,
            removeFile,
            uploadindStatus,
            listRef,
            messages,
            loading,
            fetchMessageHistory,
            createNewThread,
            isNewThread,
            sendMessage,
            navigateToLatest,
            selectedThread,
            newThreadActive,
            caseLeadList,
            isClientOptIn,
            selectedContact,
          }}
        />
        <div className="col-md-4 col-12 msg-case_details_sidebar ps-md-2 h-100 overflow-y-auto">
          <CaseLeadContainer {...{ caseLeadList }} />
        </div>
      </div>
    </div>
  );
}
